import { AxiosError } from "axios";

/**
 * Check if an error is a 401 token invalidation error
 * This helps prevent showing duplicate error messages when a user's token is invalidated
 */
export const isTokenInvalidationError = (error: unknown): boolean => {
  if (!error) return false;
  
  // Check if it's an axios error
  if (typeof error === 'object' && 'response' in error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 401) {
      const reason = (axiosError.response.data as any)?.reason;
      return reason === 'token_invalidated';
    }
  }
  
  return false;
};

/**
 * Check if we're currently in a logout process
 * This prevents showing error messages when the user is being logged out
 */
export const isLoggingOut = (): boolean => {
  return sessionStorage.getItem('__is_logging_out__') === 'true';
};

